import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { GetAvailableSlot } from '@edtech-ui/core/models/mentors-sessions/available-slots-time-session';
import { MentorSessionCancelPassData } from '@edtech-ui/core/models/mentors-sessions/mentor-cancel-pass-data';
import { MentorService } from '@edtech-ui/core/services/mentor-management/mentor.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, of, Subscription, tap } from 'rxjs';

@Component({
	selector: 'app-mentor-reschedule-dialog',
	standalone: true,
	imports: [MatIconModule, CommonModule, ReactiveFormsModule],
	templateUrl: './mentor-reschedule-dialog.component.html',
	styleUrl: './mentor-reschedule-dialog.component.scss'
})
export class MentorRescheduleDialogComponent {

	formattedSchedule = '';
	rescheduleForm: FormGroup;
	bookingId = '';
	mentorName = '';
	sessionType = '';
	sessionStartTime = '';
	sessionEndTime = '';
	sessionDate = '';
	mentorId='';
	availableTimeSlot :GetAvailableSlot[]=[];
	subscription = new Subscription();

	constructor(
		private dialogRef: MatDialogRef<MentorRescheduleDialogComponent>,
		private _toastr: ToastrService,
		private _mentorService:MentorService,
		@Inject(MAT_DIALOG_DATA) public data : MentorSessionCancelPassData
	) {

		this.mentorName = data.mentor_name,
			this.bookingId = data.booking_id,
			this.sessionType = data.session_type,
			this.sessionStartTime = data.start_time,
			this.sessionEndTime = data.end_time,
			this.sessionDate = data.appointment_date

		this.rescheduleForm = new FormGroup({
			date: new FormControl(''),
			time: new FormControl(''),
			topic:new FormControl('')
		})
	}

	close() {
		this.dialogRef.close();
	}

	postConfirmReschedule() {
		this._toastr.success('Session Rescheduled Successfully');
		this.close();
	}


	showSchedule() {
		const { date, time } = this.rescheduleForm.value;
		if (date && time) {
			const d = new Date(date);
			const dateStr = d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
			this.formattedSchedule = `${dateStr} at ${time}`;
		} else {
			this.formattedSchedule = '';
		}
	}

	getAllAvailableTimeSlots(selectedDate: string, selectedDuration: number) {
			this.subscription.add(
				this._mentorService.getAllAvailableTimeSlots(this.mentorId, selectedDate, selectedDuration).pipe(
					tap(response => {
						if (response.Success) {
							this.availableTimeSlot = response.Data.available_slots;							
						} else {
							this._toastr.error(response.Message)
						}
					}),
					catchError(() => {
						this._toastr.error('Something went wrong while fetching the time slots');
						return of(null);
					})
				).subscribe());
		}

}